import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCarrot, faEye, faPenToSquare, faQuestion } from "@fortawesome/free-solid-svg-icons"
import {  useNavigate, useParams } from 'react-router-dom'
import { useGetUserQuestionsQuery } from './userQuestionApiSlice'
import { memo } from 'react'
import useAuth from "../../hooks/useAuth"
import TimeLeft from '../../partial/TimeLeft'


const UserQuestion = ({ userQuestionId }) => {
    const {groupId, type} = useParams()
    const { isTeacher, isAdmin, isStudent } = useAuth()




    const { userQuestion } = useGetUserQuestionsQuery("userQuestionsList", {
        selectFromResult: ({ data }) => ({
            userQuestion: data?.entities[userQuestionId]
        }),
    })

    const navigate = useNavigate()
  

    if (userQuestion) {
        //const created = new Date(userQuestion.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long' })
         const handleEdit = () => navigate(`/${type}/${groupId}/user-questions/${userQuestionId}`)
         const cellStatus =''

         let buttons;
         if (!isAdmin && userQuestion.finalQuestionSet.active && !userQuestion.complete && (new Date( userQuestion.finalQuestionSet?.toDate )> new Date() && new Date( userQuestion.finalQuestionSet?.fromDate) < new Date())) {
           buttons = <button
           className="table__button bold-btn"
           onClick={handleEdit}
       >
        נסיון מענה   <FontAwesomeIcon icon={faPenToSquare} />
       </button>
         } else if(!isAdmin) {
           buttons = <button
           className="table__button"
           onClick={handleEdit}
       >
         צפייה  <FontAwesomeIcon icon={faEye} />
       </button>
         }

        
   
  
        return (
            <tr className="table__row">
                <td className={`table__cell userQuestion__title ${cellStatus}`}>{userQuestion.finalQuestionSet?.title} <span className='small-text'>{userQuestion.group?.name} </span> </td>
                <td className={`table__cell userQuestion__title ${cellStatus}`}>{userQuestion.username}</td>

                <td className={`table__cell userQuestion__title ${cellStatus}`}>{ new Date( userQuestion.finalQuestionSet?.fromDate).toLocaleString()}   </td>
                <td className={`table__cell userQuestion__title ${cellStatus}`}>{new Date(userQuestion.finalQuestionSet?.toDate).toLocaleString()}  </td>
                <td className={`table__cell userQuestion__title ${cellStatus}`}>{userQuestion.answered} מתוך {userQuestion.totalQuestions}</td>

                <td className={`table__cell userQuestion__actions ${cellStatus}`} >{userQuestion.totalScore}</td>
                <td className={`table__cell userQuestion__title ${cellStatus}`}>
                   <div className='d-flex'>

                 

         {buttons}
                    
         </div>   
                </td>
            </tr>
        )

    } else return null
}

const memoizedUserQuestion = memo(UserQuestion)

export default memoizedUserQuestion